export const en = {
    early_departures_first: 'Early departures first',
    economical_first: 'Lower cost first',
    expensive_first: 'Higher cost first',
    fast_first: 'Fast first',
    late_departures_first: 'Late departures first',
    optimal_hotel: 'Optimal (corporate and recommended)',
    optimal_train_flight: 'Optimal (by price and duration)',
};
